import React, { useContext } from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import i18n from '~/i18n';
import { Typography } from 'antd';
import { CartActionContext } from '~/App/Layout/providers/CartProvider';
import { useNavigate } from 'react-router-dom';
import '../style.css';
import { DialogContext } from '~/providers/DialogProvider';
import message from '~/utils/message';

const DeleteButton = () => {
  const { resetCart } = useContext(CartActionContext);
  const { openDialog } = useContext(DialogContext);
  const navigate = useNavigate();

  const onClick = () => {
    openDialog({
      message: i18n.t('cart_delete_dialog'),
      okText: i18n.t('cart_delete_dialog_ok'),
      cancelText: i18n.t('cart_delete_dialog_cancel'),
      onOk: () => {
        resetCart();
        navigate('/');
        message.warning(i18n.t('cart_delete_message'));
      },
    });
  };

  return (
    <div className="cart-bottom-bar-button" onClick={onClick}>
      <DeleteOutlined />
      <Typography.Text>{i18n.t('cart_delete')}</Typography.Text>
    </div>
  );
};

export default DeleteButton;
